import React from 'react'
import PropTypes from 'prop-types'
import { graphql, Link } from 'gatsby'

import ArrowRightSVG from './../../assets/svg/arrow-right.svg'

const TutorialReel = ({ header, buttonText, buttonLink, filter, videos }) => (
  <section className="c-section c-section--makeMostSubs">
    <div className="c-section__outer container">
      <div className="c-section__inner">
        <div className="c-makeMostSubs">
          <div className="row text-center">
            <div className="col-12">
              <h1>{header}</h1>
            </div>
          </div>
          <div className="row">
            {videos.map((video) => (
              <div key={video.name} className="col-12 col-lg-4">
                <div className="c-makeMostSubsItem">
                  <div className="c-makeMostSubsItem__video embed-responsive embed-responsive-16by9">
                    <iframe
                      src={video.url}
                      frameBorder="0"
                      allow="accelerometer; autoplay; fullscreen; encrypted-media; gyroscope; picture-in-picture"
                    ></iframe>
                  </div>
                  <span className="c-makeMostSubsItem__videoInfo">
                    {video.category} <span>|</span> {video.runtime}
                  </span>
                  <p className="c-makeMostSubsItem__title">{video.name}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="row text-center mt-md-3 mt-lg-5">
            <div className="col-12">
              <Link
                to={buttonLink}
                state={{ filter }}
                className="c-button c-button--secondary mb-4"
              >
                <ArrowRightSVG className="c-icon mr-2" />
                {buttonText}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
)

TutorialReel.defaultProps = {
  videos: [],
}

TutorialReel.propTypes = {
  header: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  buttonLink: PropTypes.string.isRequired,
  filter: PropTypes.string.isRequired,
  videos: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)).isRequired,
}

export default TutorialReel

export const FragmentQuery = graphql`
  fragment TutorialReelFragment on MarkdownRemarkFrontmatter {
    subVideos {
      header
      buttonText
      buttonLink
      filter
      videos {
        name
        url
        category
        runtime
      }
    }
  }
`
